import { VEHICLE_ART, VEHICLE_GRID, type Vehicle } from '../lib/vehicles'

/**
 * The picture of a vehicle (#90) -- the same shapes the animation paints,
 * from `lib/vehicles.ts`, so that the sheet and the film show one car.
 */
export function VehicleIcon({ vehicle, size = 22, className }: { vehicle: Vehicle; size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${VEHICLE_GRID} ${VEHICLE_GRID}`}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      focusable="false"
      data-vehicle={vehicle}
    >
      {VEHICLE_ART[vehicle].shapes.map((s, i) => (
        <path key={i} d={s.d} fill={s.fill} stroke={s.stroke ?? 'none'} strokeWidth={s.width} />
      ))}
    </svg>
  )
}
